import { useState, useEffect } from "react";
import {message} from "antd";
import CircularProgress from "../CircularProgress";
import FilteredTable from "../table/filteredTable";
import Widget from "../Widget";
import { pricify } from "../../util/textFormater";
import Classes from "./index.module.css";
import { ReadvisitorNewCustommer } from "../../API/addCustomers";

export default function NewCustommerDetails({ visitor }) {
  const [products, setproducts] = useState([]);
  const [loading,setLoading] =useState(true);
  useEffect(() => {
    ReadvisitorNewCustommer({ visitor: visitor }).then((i) => {
        console.log("response:",i)
      if(i.success){
        setproducts(i.data);
      }else{
        message.error("مشکلی هنگام دریافت اطلاعات رخ داد");
      }
    }).finally(()=>{
      setLoading(false);
    }).catch((e)=>{
      
      message.error("مشکلی هنگام انجام عملیات رخ داد");
    });
  }, []);
  const invoiceColumn = [
    {
      title: "مشتری",
      dataIndex: "fullname",
      key: "fullname",
      search: true,
    },
    {
      title: "آدرس",
      dataIndex: "address",
      key: "address",
      search: true,
    },
    {
      title: "شماره تماس",
      dataIndex: "mobile",
      key: "mobile",
      search: true,
    },
  ];
  return (
    <>
      {loading && <CircularProgress/>}
      {!loading && [<FilteredTable data={products} headers={invoiceColumn} />]}
    </>
  );
}
